// Wrapper de subida a S3 vía Vapor. Reutiliza createUppyInstance del factory existente
// pero maneja el cleanup con uppy.destroy() (la API de Uppy 5; el factory legacy llama
// a uppy.close() que ya no existe en esta versión).
import { createUppyInstance } from "·/components/activity-groups/utils/uppyFactory"
import { createLogger } from "../../utils/logger"

const logger = createLogger('uppy-client')

/**
 * Asegura que el File tenga un MIME type. Algunos formatos (.dxf, .dwg, .step…)
 * no tienen MIME registrado y el browser devuelve type vacío. Si no lo arreglamos,
 * uppy lo rechaza por falta de type.
 */
function _ensureMimeType(file) {
  if (!file || file.type) return file
  const ext  = (file.name || '').split('.').pop().toLowerCase()
  const mime = {
    dxf:  'application/dxf',
    dwg:  'application/acad',
    step: 'application/step',
    stp:  'application/step',
    ifc:  'application/x-step',
  }[ext] || 'application/octet-stream'
  return new File([file], file.name, { type: mime })
}

/**
 * Sube un File/Blob a S3. Cada llamada crea una instancia Uppy independiente
 * que se destruye al terminar (éxito o error).
 * @returns {Promise<{key, name, content_type}|null>}
 */
export async function uploadFile(file) {
  file = _ensureMimeType(file)

  if (!file || !file.name || !file.type) {
    logger.error('file invalid:', { file, name: file?.name, type: file?.type })
    return null
  }

  return new Promise((resolve) => {
    const { uppy } = createUppyInstance({
      onSuccess: (_uppyFile, response) => {
        uppy.destroy()
        resolve({
          key:          response.body.key,
          name:         file.name,
          content_type: file.type,
        })
      },
      onError: (_uppyFile, error) => {
        uppy.destroy()
        logger.error('upload failed:', error, {
          name: file.name, type: file.type, size: file.size,
        })
        resolve(null)
      },
    })

    uppy.addFile({ name: file.name, type: file.type, data: file })
    uppy.upload().catch((err) => {
      uppy.destroy()
      logger.error('upload threw:', err)
      resolve(null)
    })
  })
}
